
var pen = require('../assets/img/errorIcon.png');
function getCookie(name) {
    var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
    if(arr=document.cookie.match(reg)){
        return unescape(arr[2]);
    }else{
        return null;
    }
}
function setTitle (title) {
    document.title = title
    var mobile = navigator.userAgent.toLowerCase()
    if (/iphone|ipad|ipod/.test(mobile)) {
        var iframe = document.createElement('iframe')
        iframe.style.display = 'none'
        // 替换成站标favicon路径或者任意存在的较小的图片即可
        iframe.setAttribute('src', pen)
        var iframeCallback = function () {
            setTimeout(function () {
                iframe.removeEventListener('load', iframeCallback)
                document.body.removeChild(iframe)
            }, 0)
        }
        iframe.addEventListener('load', iframeCallback)
        document.body.appendChild(iframe)
    }
}
function getQueryString(name){
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var url = window.location.href;
    var r = url.substr(url.indexOf('?')).substr(1).match(reg);
    if (r != null) return decodeURI (r[2]); return null;
}

// const appUrl = 'http://test.app.kaopujinfu.com';
// const consoleUrl = 'http://test.console.kaopujinfu.com';

// const appUrl = 'http://10.28.0.236:8020';
// const consoleUrl = 'http://10.28.0.236:8060';

// const appUrl = 'http://localhost:8020';

const appUrl = 'http://app.kaopujinfu.com';
const consoleUrl = 'http://console.kaopujinfu.com';
const creditUrl = 'http://credit.kaopujinfu.com';
// const consoleUrl = 'http://localhost:8080';

export {getCookie,setTitle,getQueryString,appUrl,consoleUrl,creditUrl}




// WEBPACK FOOTER //
// ./src/tool/tool.js